module.exports = __webpack_public_path__ + "img/DE02524.784a6892.png";